"use client"

import Link from "next/link"
import Image from "next/image"
import { MessageCircle } from "lucide-react"

export function SupportHeader() {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <Link href="/" className="flex items-center">
            <Image
              src="/logo-floranza.svg"
              alt="Floriq Logo"
              width={120}
              height={40}
              className="h-10 w-auto"
              priority
            />
          </Link>

          {/* WhatsApp Link */}
          <a
            href="https://wa.me/919900005116"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-primary hover:text-primary/80 transition-colors font-medium"
          >
            <MessageCircle className="w-5 h-5" />
            <span>+91 9900005116</span>
          </a>
        </div>
      </div>
    </header>
  )
}
